import { Injectable } from '@angular/core';
import { MwHttpService } from '@core/http';
import { Observable } from 'rxjs';
import { UnitApiModel } from 'app/models/units-api.model';

@Injectable()
export class MwUnitsApiService {
  constructor(private http: MwHttpService) {}

  private apiEndpoint(version = 1): string {
    return `/transport/v${version}/Companies/{companyId}/Units`;
  }

  load(): Observable<UnitApiModel[]> {
    return this.http.authGet<UnitApiModel[]>(this.apiEndpoint(2));
  }

  create(unit: UnitApiModel): Observable<UnitApiModel> {
    return this.http.authPost<UnitApiModel>(this.apiEndpoint(), {
      body: unit,
    });
  }

  update(unit: UnitApiModel): Observable<any> {
    return this.http.authPut<UnitApiModel>(this.apiEndpoint(), {
      body: unit,
    });
  }

  delete(unit: UnitApiModel[]): Observable<any> {
    if (!(unit instanceof Array)) {
      unit = [unit];
    }
    return this.http.authDelete<UnitApiModel[]>(this.apiEndpoint(), {
      body: unit,
    });
  }
}
